import React from "react";
import {observer} from "mobx-react-lite";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";

import CompanyUserForm from "./CompanyUserForm";


const StaffForm = () => {

    const member =
        clubStore.member;


    const roleName =
        appStore.rolesLocalized.find(
            (role) =>
                role.id === member.role_id
        )?.name ||
        member.role?.name ||
        member.role_id;


    const action =
        member.id
            ? (
                appStore.tr.edit ||
                "Редактировать"
            )
            : (
                appStore.tr.add ||
                "Добавить"
            );


    const title = [
        action,
        roleName,
    ]
        .filter(Boolean)
        .join(" ");


    return (
        <CompanyUserForm
            title={title}
        />
    );
};


export default observer(
    StaffForm
);